import { useState } from 'preact/hooks';
import { get, post } from '../api';
import { Button, Card, Empty, Field, Link, money, Pill, toast, useAction, useLoad } from '../ui';

export function Admin() {
	const pending = useLoad(() => get('/api/admin/templates'));
	const [note, setNote] = useState('');
	const [review, busy] = useAction(async (id: string, approve: boolean) => {
		await post(`/api/admin/templates/${id}/review`, { approve, note });
		setNote('');
		pending.reload();
	});
	const helcim = useLoad(() => get('/api/admin/billing/helcim/plans'));
	const [setup, settingUp] = useAction(async () => {
		const r = await post('/api/admin/billing/helcim/setup-plans');
		toast(`Created ${Object.keys(r.plans).length} Helcim payment plans.`, 'ok');
		helcim.reload();
	});
	const payoutList = useLoad(() => get('/api/admin/payouts'));
	const [payouts, paying] = useAction(async () => {
		const r = await post('/api/admin/payouts/run');
		toast(`${r.payouts.length} payout(s) created.`, 'ok');
		payoutList.reload();
	});
	return (
		<main class="page">
			<h1>Admin</h1>
			<Card title="Template review queue">
				<Field label="Review note (sent to the author)">
					<input value={note} onInput={(e) => setNote(e.currentTarget.value)} />
				</Field>
				{pending.data?.templates?.length ? (
					<ul class="list">
						{pending.data.templates.map((t: any) => (
							<li key={t.id} class="row-between">
								<span>
									<Link href={`/templates/${t.id}`}>{t.title}</Link> by {t.author} · {money(t.priceCents)} {t.original ? '' : '· franchise (free only)'}
								</span>
								<span class="row">
									<Button small onClick={() => review(t.id, true)} busy={busy}>
										Approve
									</Button>
									<Button small variant="danger" onClick={() => review(t.id, false)} busy={busy}>
										Reject
									</Button>
								</span>
							</li>
						))}
					</ul>
				) : (
					<Empty>Nothing to review.</Empty>
				)}
			</Card>
			<Card title="Payments (Helcim)">
				<p>
					Mode: <strong>{helcim.data?.mode ?? '…'}</strong>. Recurring plans need a Helcim payment plan for each plan and interval.
				</p>
				{helcim.data && Object.keys(helcim.data.plans).length ? (
					<ul class="list small">
						{Object.entries(helcim.data.plans).map(([k, v]: any) => (
							<li key={k}>
								{k}: plan #{v}
							</li>
						))}
					</ul>
				) : (
					<Empty>No payment plans yet.</Empty>
				)}
				<Button onClick={() => setup()} busy={settingUp} disabled={helcim.data?.mode !== 'helcim'}>
					{helcim.data && Object.keys(helcim.data.plans).length ? 'Create a fresh set of plans' : 'Create payment plans in Helcim'}
				</Button>
			</Card>
			<Card title="Payouts">
				<p>Creates a payout for every author whose unpaid balance passed $25.</p>
				<Button onClick={() => payouts()} busy={paying}>
					Run monthly payouts
				</Button>
				{payoutList.data?.payouts?.length ? (
					<ul class="list">
						{payoutList.data.payouts.map((p: any) => (
							<li key={p.id} class="row-between">
								<span>
									{p.display_name} · {p.period} · {money(p.amount_cents)} <Pill tone={p.status === 'paid' ? 'ok' : 'warn'}>{p.status}</Pill>
								</span>
								{p.status !== 'paid' ? (
									<Button small variant="ghost" onClick={() => post(`/api/admin/payouts/${p.id}/paid`).then(payoutList.reload)}>
										Mark paid
									</Button>
								) : null}
							</li>
						))}
					</ul>
				) : null}
			</Card>
		</main>
	);
}
